import {
  APPROACHING_CONTENT_LIMIT_BANNER_DISMISSED,
  APPROACHING_CONTENT_LIMIT_CHIP_DISMISSED,
} from 'constants/localStorage';

import { useStoredStateForUser } from './utils';

export const useApproachingContentLimitBannerState = () => {
  return useStoredStateForUser(APPROACHING_CONTENT_LIMIT_BANNER_DISMISSED);
};

export const useApproachingContentLimitChipState = () => {
  return useStoredStateForUser(APPROACHING_CONTENT_LIMIT_CHIP_DISMISSED);
};
